import { code as codeMessage } from "../store/globalSettings";

const messages = value => {
  if (typeof value === "string") return [value];
  if (Array.isArray(value)) return value.flatMap(messages);
  if (value && typeof value === "object") return Object.values(value).flatMap(messages);
  return [];
};

export function normalizeError(error) {
  const payload = error?.response?.data || error;
  const fieldErrors = payload?.fieldErrors || payload?.errors || {};
  const message = messages(fieldErrors).join(" ") || messages(payload?.message).join(" ") ||
    messages(typeof payload === "string" || Array.isArray(payload) ? payload : null).join(" ") ||
    (payload?.code ? codeMessage(payload.code) : "Unable to complete the request. Please try again.");
  return { message, fieldErrors, code: payload?.code, status: error?.status || error?.response?.status };
}

export function assertSuccess(payload, isSuccess = value => value?.code === undefined || value.code === "success") {
  if (!isSuccess(payload)) throw toRequestError(payload);
  return payload;
}

function toRequestError(payload) {
  const details = normalizeError(payload);
  return Object.assign(new Error(details.message), details);
}

// Fetch transport: every HTTP, parsing and application error rejects.
export async function request(url, options = {}, { isSuccess, select = value => value, responseType = "json" } = {}) {
  const response = await fetch(url, options);
  if (responseType === "blob" && response.ok) return select(await response.blob());
  let payload;
  try {
    payload = response.status === 204 ? null : await response.json();
  } catch {
    throw toRequestError({ message: "The server returned an invalid response.", status: response.status });
  }
  if (!response.ok) throw toRequestError({ ...payload, status: response.status });
  return select(assertSuccess(payload, isSuccess));
}
